import script from "./LinkBodySkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkBodySkeleton.vue?vue&type=script&setup=true&lang=js"

import "./LinkBodySkeleton.vue?vue&type=style&index=0&id=6c2fc592&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2fc592"]])

export default __exports__